import { useContext } from 'react';
import { AuthContext } from 'auth/contexts/AuthProvider';

export function useAuth() {
  return useContext(AuthContext);
}
